import styled from "styled-components";
import NewsBgImg from './newsbg.jpg';

export const BackgroundDiv = styled.div`
    display: grid;
    grid-template-columns: 3fr 2fr;
    grid-template-rows: 10% 90%;
    width: 100vw;
    height: 100vh;
    overflow: hidden;

    @media(max-height: 960px) {
        overflow-y: auto;
    }
    @media(max-width: 1250px) {
        grid-template-columns: 1fr 1fr;
    }

    @media(max-width: 940px) {
        grid-template-columns: 2fr 3fr;
    }

    @media(max-width: 860px) {
        grid-template-columns: 1fr;
        grid-template-rows: 10% 20% 70%;
        row-gap: 1rem;
    }

    @media(max-width: 490px) {
        overflow-y: auto;
    }

    @media(max-height: 700px) and (max-width: 860px) {
        row-gap: 3rem;
    }
`;


export const SignUpBackground = styled.div`
    background: url(${NewsBgImg}) no-repeat center/cover;
    background-color: #CAC7C2;
    grid-column-start: 1;
    grid-row: 1 / 3;

    @media(max-width: 860px) {
        grid-row: 2
    }
`;

export const SignUpFormDiv = styled.div`
    margin: auto 0;
    padding: 0 5rem;
    grid-column-start: 2;

    @media(max-width: 860px) {
        grid-column-start: 1;
        margin: 0;
        padding: 3rem 1rem;
    }

    
    @media(max-width: 490px) {
        padding: 0 1rem;
    }

    @media(max-height: 700px) {
        padding-top: 0;
        padding-bottom: 2rem;
    }
`;
